export default {
    AREA_LIST: {
        "code": 200,
        "data": {
            "address": [
                {
                    "id": "34",
                    "code": "520000000000",
                    "name": "贵州省",
                    "subAddress": [
                        {
                            "id": "35",
                            "code": "520100000000",
                            "name": "贵阳市",
                            "subAddress": [
                                {
                                    "id": "67",
                                    "code": "520103000000",
                                    "name": "云岩区",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "68",
                                    "code": "520102000000",
                                    "name": "南明区",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "69",
                                    "code": "520111000000",
                                    "name": "花溪区",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "70",
                                    "code": "520122000000",
                                    "name": "息烽县",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "71",
                                    "code": "520121000000",
                                    "name": "开阳县",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "72",
                                    "code": "520100000002",
                                    "name": "经开区",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "73",
                                    "code": "520123000000",
                                    "name": "修文县",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "74",
                                    "code": "520113000000",
                                    "name": "白云区",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "75",
                                    "code": "520181000000",
                                    "name": "清镇市",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "76",
                                    "code": "520112000000",
                                    "name": "乌当区",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "77",
                                    "code": "520115000000",
                                    "name": "观山湖区",
                                    "subAddress": null,
                                    "pid": "35"
                                },
                                {
                                    "id": "155",
                                    "code": "520183000000",
                                    "name": "双龙航空港经济区",
                                    "subAddress": null,
                                    "pid": "35"
                                }
                            ],
                            "pid": "34"
                        },
                        {
                            "id": "36",
                            "code": "520300000000",
                            "name": "遵义市",
                            "subAddress": [
                                {
                                    "id": "139",
                                    "code": "520304000000",
                                    "name": "播州区",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "140",
                                    "code": "520381000000",
                                    "name": "赤水市",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "141",
                                    "code": "520325000000",
                                    "name": "道真县",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "142",
                                    "code": "520327000000",
                                    "name": "凤冈县",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "143",
                                    "code": "520328000000",
                                    "name": "湄潭县",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "144",
                                    "code": "520382000000",
                                    "name": "仁怀市",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "145",
                                    "code": "520323000000",
                                    "name": "绥阳县",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "146",
                                    "code": "520322000000",
                                    "name": "桐梓县",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "147",
                                    "code": "520326000000",
                                    "name": "务川县",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "148",
                                    "code": "520330000000",
                                    "name": "习水县",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "149",
                                    "code": "520329000000",
                                    "name": "余庆县",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "150",
                                    "code": "520324000000",
                                    "name": "正安县",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "151",
                                    "code": "520303000000",
                                    "name": "汇川区",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "156",
                                    "code": "520302000000",
                                    "name": "红花岗区",
                                    "subAddress": null,
                                    "pid": "36"
                                },
                                {
                                    "id": "157",
                                    "code": "520384000000",
                                    "name": "新蒲新区",
                                    "subAddress": null,
                                    "pid": "36"
                                }
                            ],
                            "pid": "34"
                        },
                        {
                            "id": "37",
                            "code": "520200000000",
                            "name": "六盘水市",
                            "subAddress": [
                                {
                                    "id": "45",
                                    "code": "520203000000",
                                    "name": "六枝特区",
                                    "subAddress": null,
                                    "pid": "37"
                                },
                                {
                                    "id": "46",
                                    "code": "520201000000",
                                    "name": "钟山区",
                                    "subAddress": null,
                                    "pid": "37"
                                },
                                {
                                    "id": "47",
                                    "code": "520281000000",
                                    "name": "盘州市",
                                    "subAddress": null,
                                    "pid": "37"
                                },
                                {
                                    "id": "48",
                                    "code": "520221000000",
                                    "name": "水城县",
                                    "subAddress": null,
                                    "pid": "37"
                                }
                            ],
                            "pid": "34"
                        },
                        {
                            "id": "38",
                            "code": "520400000000",
                            "name": "安顺市",
                            "subAddress": [
                                {
                                    "id": "78",
                                    "code": "520402000000",
                                    "name": "西秀区",
                                    "subAddress": null,
                                    "pid": "38"
                                },
                                {
                                    "id": "79",
                                    "code": "520403000000",
                                    "name": "平坝区",
                                    "subAddress": null,
                                    "pid": "38"
                                },
                                {
                                    "id": "80",
                                    "code": "520422000000",
                                    "name": "普定县",
                                    "subAddress": null,
                                    "pid": "38"
                                },
                                {
                                    "id": "81",
                                    "code": "520423000000",
                                    "name": "镇宁县",
                                    "subAddress": null,
                                    "pid": "38"
                                },
                                {
                                    "id": "82",
                                    "code": "520424000000",
                                    "name": "关岭县",
                                    "subAddress": null,
                                    "pid": "38"
                                },
                                {
                                    "id": "83",
                                    "code": "520425000000",
                                    "name": "紫云县",
                                    "subAddress": null,
                                    "pid": "38"
                                },
                                {
                                    "id": "38170",
                                    "code": "520491000000",
                                    "name": "经济技术开发区",
                                    "subAddress": null,
                                    "pid": "38"
                                },
                                {
                                    "id": "38168",
                                    "code": "520492000000",
                                    "name": "黄果树旅游区",
                                    "subAddress": null,
                                    "pid": "38"
                                }

                            ],
                            "pid": "34"
                        },
                        {
                            "id": "39",
                            "code": "520500000000",
                            "name": "毕节市",
                            "subAddress": [
                                {
                                    "id": "84",
                                    "code": "520521000000",
                                    "name": "大方县",
                                    "subAddress": null,
                                    "pid": "39"
                                },
                                {
                                    "id": "85",
                                    "code": "520526000000",
                                    "name": "威宁县",
                                    "subAddress": null,
                                    "pid": "39"
                                },
                                {
                                    "id": "86",
                                    "code": "520527000000",
                                    "name": "赫章县",
                                    "subAddress": null,
                                    "pid": "39"
                                },
                                {
                                    "id": "87",
                                    "code": "520523000000",
                                    "name": "金沙县",
                                    "subAddress": null,
                                    "pid": "39"
                                },
                                {
                                    "id": "88",
                                    "code": "520524000000",
                                    "name": "织金县",
                                    "subAddress": null,
                                    "pid": "39"
                                },
                                {
                                    "id": "89",
                                    "code": "520525000000",
                                    "name": "纳雍县",
                                    "subAddress": null,
                                    "pid": "39"
                                },
                                {
                                    "id": "90",
                                    "code": "520522000000",
                                    "name": "黔西县",
                                    "subAddress": null,
                                    "pid": "39"
                                },
                                {
                                    "id": "91",
                                    "code": "520500000001",
                                    "name": "金海湖新区",
                                    "subAddress": null,
                                    "pid": "39"
                                },
                                {
                                    "id": "92",
                                    "code": "520500000002",
                                    "name": "百里杜鹃风景区",
                                    "subAddress": null,
                                    "pid": "39"
                                },
                                {
                                    "id": "93",
                                    "code": "520502000000",
                                    "name": "七星关区",
                                    "subAddress": null,
                                    "pid": "39"
                                }
                            ],
                            "pid": "34"
                        },
                        {
                            "id": "40",
                            "code": "520600000000",
                            "name": "铜仁市",
                            "subAddress": [
                                {
                                    "id": "110",
                                    "code": "520623000000",
                                    "name": "石阡县",
                                    "subAddress": null,
                                    "pid": "40"
                                },
                                {
                                    "id": "111",
                                    "code": "520622000000",
                                    "name": "玉屏县",
                                    "subAddress": null,
                                    "pid": "40"
                                },
                                {
                                    "id": "112",
                                    "code": "520602000000",
                                    "name": "碧江区",
                                    "subAddress": null,
                                    "pid": "40"
                                },
                                {
                                    "id": "113",
                                    "code": "520626000000",
                                    "name": "德江县",
                                    "subAddress": null,
                                    "pid": "40"
                                },
                                {
                                    "id": "114",
                                    "code": "520621000000",
                                    "name": "江口县",
                                    "subAddress": null,
                                    "pid": "40"
                                },
                                {
                                    "id": "115",
                                    "code": "520603000000",
                                    "name": "万山区",
                                    "subAddress": null,
                                    "pid": "40"
                                },
                                {
                                    "id": "116",
                                    "code": "520627000000",
                                    "name": "沿河县",
                                    "subAddress": null,
                                    "pid": "40"
                                },
                                {
                                    "id": "117",
                                    "code": "520628000000",
                                    "name": "松桃县",
                                    "subAddress": null,
                                    "pid": "40"
                                },
                                {
                                    "id": "152",
                                    "code": "520625000000",
                                    "name": "印江县",
                                    "subAddress": null,
                                    "pid": "40"
                                },
                                {
                                    "id": "153",
                                    "code": "520624000000",
                                    "name": "思南县",
                                    "subAddress": null,
                                    "pid": "40"
                                }
                            ],
                            "pid": "34"
                        },
                        {
                            "id": "41",
                            "code": "522600000000",
                            "name": "黔东南州",
                            "subAddress": [
                                {
                                    "id": "94",
                                    "code": "522601000000",
                                    "name": "凯里市",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "95",
                                    "code": "522636000000",
                                    "name": "丹寨县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "96",
                                    "code": "522635000000",
                                    "name": "麻江县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "97",
                                    "code": "522622000000",
                                    "name": "黄平县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "98",
                                    "code": "522623000000",
                                    "name": "施秉县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "99",
                                    "code": "522625000000",
                                    "name": "镇远县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "100",
                                    "code": "522626000000",
                                    "name": "岑巩县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "101",
                                    "code": "522624000000",
                                    "name": "三穗县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "102",
                                    "code": "522627000000",
                                    "name": "天柱县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "103",
                                    "code": "522628000000",
                                    "name": "锦屏县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "104",
                                    "code": "522631000000",
                                    "name": "黎平县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "105",
                                    "code": "522633000000",
                                    "name": "从江县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "106",
                                    "code": "522632000000",
                                    "name": "榕江县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "107",
                                    "code": "522634000000",
                                    "name": "雷山县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "108",
                                    "code": "522630000000",
                                    "name": "台江县",
                                    "subAddress": null,
                                    "pid": "41"
                                },
                                {
                                    "id": "109",
                                    "code": "522629000000",
                                    "name": "剑河县",
                                    "subAddress": null,
                                    "pid": "41"
                                }
                            ],
                            "pid": "34"
                        },
                        {
                            "id": "42",
                            "code": "522700000000",
                            "name": "黔南州",
                            "subAddress": [
                                {
                                    "id": "127",
                                    "code": "522701000000",
                                    "name": "都匀市",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "128",
                                    "code": "522726000000",
                                    "name": "独山县",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "129",
                                    "code": "522702000000",
                                    "name": "福泉市",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "130",
                                    "code": "522723000000",
                                    "name": "贵定县",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "131",
                                    "code": "522731000000",
                                    "name": "惠水县",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "132",
                                    "code": "522722000000",
                                    "name": "荔波县",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "133",
                                    "code": "522730000000",
                                    "name": "龙里县",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "134",
                                    "code": "522728000000",
                                    "name": "罗甸县",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "135",
                                    "code": "522727000000",
                                    "name": "平塘县",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "136",
                                    "code": "522732000000",
                                    "name": "三都县",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "137",
                                    "code": "522725000000",
                                    "name": "瓮安县",
                                    "subAddress": null,
                                    "pid": "42"
                                },
                                {
                                    "id": "138",
                                    "code": "522729000000",
                                    "name": "长顺县",
                                    "subAddress": null,
                                    "pid": "42"
                                }
                            ],
                            "pid": "34"
                        },
                        {
                            "id": "43",
                            "code": "522300000000",
                            "name": "黔西南州",
                            "subAddress": [
                                {
                                    "id": "118",
                                    "code": "522301000000",
                                    "name": "兴义市",
                                    "subAddress": null,
                                    "pid": "43"
                                },
                                {
                                    "id": "119",
                                    "code": "522302000000",
                                    "name": "兴仁市",
                                    "subAddress": null,
                                    "pid": "43"
                                },
                                {
                                    "id": "120",
                                    "code": "522328000000",
                                    "name": "安龙县",
                                    "subAddress": null,
                                    "pid": "43"
                                },
                                {
                                    "id": "121",
                                    "code": "522325000000",
                                    "name": "贞丰县",
                                    "subAddress": null,
                                    "pid": "43"
                                },
                                {
                                    "id": "122",
                                    "code": "522323000000",
                                    "name": "普安县",
                                    "subAddress": null,
                                    "pid": "43"
                                },
                                {
                                    "id": "123",
                                    "code": "522324000000",
                                    "name": "晴隆县",
                                    "subAddress": null,
                                    "pid": "43"
                                },
                                {
                                    "id": "124",
                                    "code": "522327000000",
                                    "name": "册亨县",
                                    "subAddress": null,
                                    "pid": "43"
                                },
                                {
                                    "id": "125",
                                    "code": "522326000000",
                                    "name": "望谟县",
                                    "subAddress": null,
                                    "pid": "43"
                                },
                                {
                                    "id": "126",
                                    "code": "522301000001",
                                    "name": "义龙新区",
                                    "subAddress": null,
                                    "pid": "43"
                                }
                            ],
                            "pid": "34"
                        },
                        {
                            "id": "44",
                            "code": "520100000001",
                            "name": "贵安新区",
                            "subAddress": [
                                {
                                    "id": "154",
                                    "code": "520100000003",
                                    "name": "贵安新区辖区",
                                    "subAddress": null,
                                    "pid": "44"
                                }
                            ],
                            "pid": "34"
                        }
                    ],
                    "pid": null
                }
            ]
        },
        "message": "success"
    },
    // 外省随行活动数据
    WHOLE_SUIXINGA_CTIVITY_LIST: {
        "code": 200,
        "data": [
            {
                "id": "-3",
                "name": "随行港澳",
                "cityName": "",
                "villageName": "澳门/香港",
                "naturalVillageName": "澳门/香港",
                "beginTime": "2021-01-25",
                "endTime": "2021-06-11",
                "listBannerUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/suixinggangaoCover.png", //列表封面url
                "headPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/suixinggangaoBanner.png", //详情bannerurl
                "detailPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/suixinggangaoDetail.png", //详情介绍url
                "forwardTitle": "随行港澳", //转发标题
                "forwardCoverUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/suixinggangaoCover.jpg", //转发卡片图url
                "signUpBeginTime": "2021-01-25",
                "voteEndTime": "2021-06-11",
                "stage": 7,
                "isUploadWork": 2,
                "lon": '113.64595',
                "lat": '22.14223',
                "source": "全国",
                "expertList": [],
            },
            {
                "id": "-2",
                "name": "2019随行潜山—中国传统村落大学生暑期工作营",
                "cityName": "潜山市",
                "villageName": "万涧村",
                "naturalVillageName": "万涧村",
                "beginTime": "2019-08-19",
                "endTime": "2019-08-24",
                "listBannerUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/static/activity_walk/qianshan0926.png", //列表封面url
                "headPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/static/activity_walk/qianshan_head_0926.png", //详情bannerurl
                "detailPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/suixingqianshanDetail.png", //详情介绍url
                "forwardTitle": "2019随行潜山—中国传统村落大学生暑期工作营", //转发标题
                "forwardCoverUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/suixingqianshanCover.jpg", //转发卡片图url
                "signUpBeginTime": "2019-08-19",
                "voteEndTime": "2019-08-24",
                "stage": 7,
                "isUploadWork": 1,
                "lon": '116.51180',
                "lat": '30.75916',
                "expertList": [
                    {
                        "id": "-1",
                        "source": "全国",
                        "name": "胡文娜",
                        "unit": "中规院",
                        "position": "全国科普工作先进工作者、随行传统村落大学生暑湖工作营常任导师、中国城市规划设计研究院高级规划师",
                        "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/huwenna.png",
                        "introduction": "胡文娜，女，全国科普工作先进工作者，住建部第五批传统村落评审专家。她常年在传统村落保护发展和乡村减贫领域工作，承担有中国传统村落数字博物馆安徽六县十村建馆编制、湖北红安县传统村落数字博物馆编制、安徽优秀传统村落遗产报告等课题和项目，随行传统村落大学生暑期工作营的策划人之一和常任导师。获得华夏科技进步奖一等奖，著有《安徽优秀传统村落遗产研究报告》一书。",
                    },
                    {
                        "id": "-2",
                        "source": "全国",
                        "name": "唐燕",
                        "unit": "清华大学                    ",
                        "position": "清华大学建筑学院长聘副救授、博士生导师、随行传统村落大学生暑期工作营常任导师",
                        "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/tangyan.jpg",
                        "introduction": "唐燕，清华大学城市规划与设计博士，现任清华大学建筑学院长聘副教授，博士生导师，院长助理；《China City Planning Review》杂志责任编辑；清华大学建筑设计研究院城市更新及乡村振兴中心主任；德国洪堡学者，麻省理工学院、卡迪夫城市大学、德国多特蒙德大学与柏林大学访问学者。先后担任中国城市规划学会城市更新学委会副秘书长、中国建筑学会城市设计分会理事、中国城市科学研究会韧性城市专委会和生态城市研究专业委员会委员、北京城市规划学会工业遗产保护利用研究中心专家等。研究兴趣主要关注城市设计、城市更新、详细规划及城乡规划治理。出版有《城市更新制度建设》《文化、创意产业与城市更新》《城市设计运作的制度与制度环境》《Urban Regeneration in China》等10余部中英文著作。",
                    },
                    {
                        "id": "-3",
                        "source": "全国",
                        "name": "黄蔚欣",
                        "unit": "清华大学",
                        "position": "清华大学建筑学院副教授",
                        "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/huangweixin.jpg",
                        "introduction": "黄蔚欣，日本京都大学工学研究科建筑学专攻建筑计画学博士，现任清华大学建筑学院建筑技术科学系副教授；美国南加州大学(USC)建筑学院、瑞士苏黎世理工大学(ETH) 访问学者；全国高等学校建筑学学科专业指导委员会数字建筑技术教学工作委员会副主任委员；中国建筑学会建筑师分会数字建筑设计专业委员会联合发起人；中国环境行为学会委员等。教学和研究方向：人机结合的空间认知、大数据环境行为研究、编织结构。先后发表了《盒子结构建筑》、《算法生形》、《基于Wi-Fi定位数据的人群特征探究》、《Behavior Analysis and Individual Labeling  Using Data from Wi-Fi IPS》等50余部中日英文著作。",
                    },
                    {
                        "id": "-4",
                        "source": "全国",
                        "name": "郑小东",
                        "unit": "北京林业大学",
                        "position": "北京林业大学园林学院教授",
                        "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhengxiaodong.jpg",
                        "introduction": "郑小东，清华大学博士，现任北京林业大学教授，中国民族建筑研究会民居建筑分会理事，获北京建造节优秀指导教师、“联合教学，多元探索——三校本科联合毕业设计的经验与思考”，北京林业大学2018年教育教学研究论文二等奖。主要研究领域：风景建筑、地域性建筑、建构学、国家公园建筑学。先后发表《材料与建造的故事》、《传统材料 当代建构》、《风景园林建筑快速设计》等多部著作，《当代瑞士建筑》、《柏林博物馆岛——艺术与科学的圣殿》、《延续传统，承载乡愁——论新乡土建筑的场所营造》、《斯陀园点景建筑的历史与类型研究》等20余篇论文。",
                    },
                ],
                "source": "全国"
            },
            {
                "id": "-1",
                "name": "2018随行红安—中国传统村落大学生暑期工作营",
                "cityName": "黄冈市",
                "villageName": "陡山村/祝家楼村",
                "naturalVillageName": "陡山村/祝家楼村",
                "beginTime": "2018-08-06",
                "endTime": "2018-08-10",
                "listBannerUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/static/activity_walk/hongan0926.png", //列表封面url
                "headPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/static/activity_walk/hongan_head_0926.png", //详情bannerurl
                "detailPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/suixinghonganDetail.png", //详情介绍url
                "forwardTitle": "2018随行红安—中国传统村落大学生暑期工作营", //转发标题
                "forwardCoverUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/suixinghonganCover.jpg", //转发卡片图url
                "signUpBeginTime": "2018-08-06",
                "voteEndTime": "2018-08-10",
                "stage": 7,
                "isUploadWork": 1,
                "lon": '114.68898',
                "lat": '31.06622',
                "expertList": [
                    {
                        "id": "-1",
                        "source": "全国",
                        "name": "胡文娜",
                        "unit": "中规院",
                        "position": "全国科普工作先进工作者、随行传统村落大学生暑湖工作营常任导师、中国城市规划设计研究院高级规划师",
                        "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/huwenna.png",
                        "introduction": "胡文娜，女，全国科普工作先进工作者，住建部第五批传统村落评审专家。她常年在传统村落保护发展和乡村减贫领域工作，承担有中国传统村落数字博物馆安徽六县十村建馆编制、湖北红安县传统村落数字博物馆编制、安徽优秀传统村落遗产报告等课题和项目，随行传统村落大学生暑期工作营的策划人之一和常任导师。获得华夏科技进步奖一等奖，著有《安徽优秀传统村落遗产研究报告》一书。",
                    },
                    {
                        "id": "-2",
                        "source": "全国",
                        "name": "唐燕",
                        "unit": "清华大学                    ",
                        "position": "清华大学建筑学院长聘副救授、博士生导师、随行传统村落大学生暑期工作营常任导师",
                        "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/tangyan.jpg",
                        "introduction": "唐燕，清华大学城市规划与设计博士，现任清华大学建筑学院长聘副教授，博士生导师，院长助理；《China City Planning Review》杂志责任编辑；清华大学建筑设计研究院城市更新及乡村振兴中心主任；德国洪堡学者，麻省理工学院、卡迪夫城市大学、德国多特蒙德大学与柏林大学访问学者。先后担任中国城市规划学会城市更新学委会副秘书长、中国建筑学会城市设计分会理事、中国城市科学研究会韧性城市专委会和生态城市研究专业委员会委员、北京城市规划学会工业遗产保护利用研究中心专家等。研究兴趣主要关注城市设计、城市更新、详细规划及城乡规划治理。出版有《城市更新制度建设》《文化、创意产业与城市更新》《城市设计运作的制度与制度环境》《Urban Regeneration in China》等10余部中英文著作。",
                    },
                    {
                        "id": "-3",
                        "source": "全国",
                        "name": "黄蔚欣",
                        "unit": "清华大学",
                        "position": "清华大学建筑学院副教授",
                        "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/huangweixin.jpg",
                        "introduction": "黄蔚欣，日本京都大学工学研究科建筑学专攻建筑计画学博士，现任清华大学建筑学院建筑技术科学系副教授；美国南加州大学(USC)建筑学院、瑞士苏黎世理工大学(ETH) 访问学者；全国高等学校建筑学学科专业指导委员会数字建筑技术教学工作委员会副主任委员；中国建筑学会建筑师分会数字建筑设计专业委员会联合发起人；中国环境行为学会委员等。教学和研究方向：人机结合的空间认知、大数据环境行为研究、编织结构。先后发表了《盒子结构建筑》、《算法生形》、《基于Wi-Fi定位数据的人群特征探究》、《Behavior Analysis and Individual Labeling  Using Data from Wi-Fi IPS》等50余部中日英文著作。",
                    },
                ],
                "source": "全国"
            },
        ],
        "message": null,
        "size": null,
        "totalCount": 3
    },
    // 专家列表
    EXPERT_LIST: {
        "code": 200,
        "data": [
            {
                "id": "-1",
                "source": "全国",
                "name": "胡文娜",
                "unit": "中规院",
                "position": "全国科普工作先进工作者、随行传统村落大学生暑湖工作营常任导师、中国城市规划设计研究院高级规划师",
                "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/huwenna.png",
                "introduction": "胡文娜，女，全国科普工作先进工作者，住建部第五批传统村落评审专家。她常年在传统村落保护发展和乡村减贫领域工作，承担有中国传统村落数字博物馆安徽六县十村建馆编制、湖北红安县传统村落数字博物馆编制、安徽优秀传统村落遗产报告等课题和项目，随行传统村落大学生暑期工作营的策划人之一和常任导师。获得华夏科技进步奖一等奖，著有《安徽优秀传统村落遗产研究报告》一书。",
            },
            {
                "id": "-2",
                "source": "全国",
                "name": "唐燕",
                "unit": "清华大学                    ",
                "position": "清华大学建筑学院长聘副救授、博士生导师、随行传统村落大学生暑期工作营常任导师",
                "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/tangyan.jpg",
                "introduction": "唐燕，清华大学城市规划与设计博士，现任清华大学建筑学院长聘副教授，博士生导师，院长助理；《China City Planning Review》杂志责任编辑；清华大学建筑设计研究院城市更新及乡村振兴中心主任；德国洪堡学者，麻省理工学院、卡迪夫城市大学、德国多特蒙德大学与柏林大学访问学者。先后担任中国城市规划学会城市更新学委会副秘书长、中国建筑学会城市设计分会理事、中国城市科学研究会韧性城市专委会和生态城市研究专业委员会委员、北京城市规划学会工业遗产保护利用研究中心专家等。研究兴趣主要关注城市设计、城市更新、详细规划及城乡规划治理。出版有《城市更新制度建设》《文化、创意产业与城市更新》《城市设计运作的制度与制度环境》《Urban Regeneration in China》等10余部中英文著作。",
            },
            {
                "id": "-3",
                "source": "全国",
                "name": "黄蔚欣",
                "unit": "清华大学",
                "position": "清华大学建筑学院副教授",
                "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/huangweixin.jpg",
                "introduction": "黄蔚欣，日本京都大学工学研究科建筑学专攻建筑计画学博士，现任清华大学建筑学院建筑技术科学系副教授；美国南加州大学(USC)建筑学院、瑞士苏黎世理工大学(ETH) 访问学者；全国高等学校建筑学学科专业指导委员会数字建筑技术教学工作委员会副主任委员；中国建筑学会建筑师分会数字建筑设计专业委员会联合发起人；中国环境行为学会委员等。教学和研究方向：人机结合的空间认知、大数据环境行为研究、编织结构。先后发表了《盒子结构建筑》、《算法生形》、《基于Wi-Fi定位数据的人群特征探究》、《Behavior Analysis and Individual Labeling  Using Data from Wi-Fi IPS》等50余部中日英文著作。",
            },
            {
                "id": "-4",
                "source": "全国",
                "name": "郑小东",
                "unit": "北京林业大学",
                "position": "北京林业大学园林学院教授",
                "photo": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhengxiaodong.jpg",
                "introduction": "郑小东，清华大学博士，现任北京林业大学教授，中国民族建筑研究会民居建筑分会理事，获北京建造节优秀指导教师、“联合教学，多元探索——三校本科联合毕业设计的经验与思考”，北京林业大学2018年教育教学研究论文二等奖。主要研究领域：风景建筑、地域性建筑、建构学、国家公园建筑学。先后发表《材料与建造的故事》、《传统材料 当代建构》、《风景园林建筑快速设计》等多部著作，《当代瑞士建筑》、《柏林博物馆岛——艺术与科学的圣殿》、《延续传统，承载乡愁——论新乡土建筑的场所营造》、《斯陀园点景建筑的历史与类型研究》等20余篇论文。",
            },
        ],
        "message": null,
        "size": null,
        "totalCount": 3
    },
    // 作品列表
    WORKS_LIST: {
        "code": 200,
        "data": [
            {
                "id": '-1',
                "activityId": '-1',
                "name": "皮影故事新编",
                "description": "该作品名称为“戲中戲“，讲诉的是陡山皮影传统人的故事，同时融入现代元素，为非遗皮影戏的传承提供了新的思路......",
                "type": 3,
                "link": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/piyingxiVideo.mp4",
                "coverPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/piyingxiCover.jpg",
                "createTime": "2018.8.10 18:00:00",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "signUpInfoName": "",
                "signUpInfoPhone": "",
                "signUpInfoSchool": "",
                "source": "全国"
            },
            {
                "id": '-2',
                "activityId": '-1',
                "name": "祝家楼村手绘地图",
                "description": "通过分组实地勘察调研，结合全景技术，以手绘的形式加深对祝家楼村的认识，助力传统村落的保护与发展。",
                "type": 2,
                "link": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhujialouMap.jpg",
                "coverPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhujialouMap.jpg",
                "createTime": "2018.8.10 18:05:00",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "signUpInfoName": "",
                "signUpInfoPhone": "",
                "signUpInfoSchool": "",
                "source": "全国"
            },
            {
                "id": '-3',
                "activityId": '-1',
                "name": "陡山村手绘地图",
                "description": "“如何更好的把我们这几天的所闻所感展示出来？那我们就为村里手绘一份地图吧“这是两个营员之间的对话，他们通过手绘的方式，让传统村落陡山村以另一种形式得存在，这对他们自己以及陡山村来说都是一笔宝贵的财富。",
                "type": 2,
                "link": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/tushanMap.jpg",
                "coverPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/tushanMap.jpg",
                "createTime": "2018.8.10 18:13:00",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "signUpInfoName": "",
                "signUpInfoPhone": "",
                "signUpInfoSchool": "",
                "source": "全国"
            },
            {
                "id": '-4',
                "activityId": '-1',
                "name": "祝家楼村全景应用",
                "description": "通过传统村落与数字技术进行结合，使得遭到破坏或者被遗弃的村落能够以全新的形式进行展现，助力传统村落的传承传播。",
                "type": 1,
                "link": "https://360s.dmctv.cn/vizen/project/village_pc/src/index.html?albumid=F5EFC63EAD4340E2A4FB0F00DA41B327&businessid=2081",
                "coverPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhujialouPanoCover.jpg",
                "createTime": "2018.8.10 18:30:00",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "signUpInfoName": "",
                "signUpInfoPhone": "",
                "signUpInfoSchool": "",
                "source": "全国"
            },
            {
                "id": '-5',
                "activityId": '-1',
                "name": "陡山村全景应用",
                "description": "通过传统村落与数字技术进行结合，使得遭到破坏或者被遗弃的村落能够以全新的形式进行展现，助力传统村落的传承传播。",
                "type": 1,
                "link": "https://360s.dmctv.cn/vizen/project/village_pc/src/index.html?albumid=32CD38E894914D488F0C0A64154B81A0&businessid=2080",
                "coverPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/tushanPanoCover.jpg",
                "createTime": "2018.8.10 18:30:00",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "signUpInfoName": "",
                "signUpInfoPhone": "",
                "signUpInfoSchool": "",
                "source": "全国"
            },
            {
                "id": '-6',
                "activityId": '-2',
                "name": "编制结构-球体",
                "description": "万涧从古就有竹编的历史，本次随行活动结合竹子这一当地盛产的自然资源，搭建了两个竹构作品，结合自身的专业知识为村庄平添一抹新意。",
                "type": 3,
                "link": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/ballwanchengshiVideo.mp4",
                "coverPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/ballwanchengshiCover.jpg",
                "createTime": "2019.8.24 17:00:00",
                "activityName": "2019随行潜山—中国传统村落大学生暑期工作营",
                "signUpInfoName": "",
                "signUpInfoPhone": "",
                "signUpInfoSchool": "",
                "source": "全国"
            },
            {
                "id": '-7',
                "activityId": '-2',
                "name": "竹构作品-竹亭",
                "description": "除了竹球之外，另一个作品更注重实用性，为村民们制作的竹亭结合传统竹编技术的同时，外形新颖别致，还未村民提供了遮风挡雨的新选择。作品完成后就有村民前来体验，纷纷为作品点赞。",
                "type": 2,
                "link": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhugouzuopin.jpg",
                "coverPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhugouzuopin.jpg",
                "createTime": "2019.8.24 17:30:00",
                "activityName": "2019随行潜山—中国传统村落大学生暑期工作营",
                "signUpInfoName": "",
                "signUpInfoPhone": "",
                "signUpInfoSchool": "",
                "source": "全国"
            },
            {
                "id": '-8',
                "activityId": '-2',
                "name": "杨家老屋手绘地图",
                "description": "团队成员手绘制作了当地富有盛名的古建地图，拥有百年历史的古村古建不仅拥有了新一批的大学生前来参观，还拥有了自己的新地图。大家都用各自的方式为保护与发展传统村落添一份力。",
                "type": 2,
                "link": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/yangjialaowuMap.jpg",
                "coverPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/yangjialaowuMap.jpg",
                "createTime": "2019.8.24 17:45:00",
                "activityName": "2019随行潜山—中国传统村落大学生暑期工作营",
                "signUpInfoName": "",
                "signUpInfoPhone": "",
                "signUpInfoSchool": "",
                "source": "全国"
            },
            // {
            //     "id": '-9',
            //     "activityId": '-2',
            //     "name": "万涧村全景应用",
            //     "description": "营员跟随老师学习了全景轻应用的制作方式，为万涧古村制作了全景地图，用高科技新手段助力传统村落发展。全景地图的制作完成只是营员们学习知识的一小步，更是传统村落保护发展的一大步。",
            //     "type": 1,
            //     "link": "https://720yun.com/t/9fvknbpqrf7?scene_id=32471766",
            //     "coverPictureUrl": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/wanjiancunPanoCover.jpg",
            //     "createTime": "2019.8.24 18:00:00",
            //     "activityName": "2019随行潜山—中国传统村落大学生暑期工作营",
            //     "signUpInfoName": "",
            //     "signUpInfoPhone": "",
            //     "signUpInfoSchool": "",
            //     "source": "全国"
            // },
        ],
        "message": null,
        "size": null,
        "totalCount": 5
    },
    // 精彩瞬间列表
    WONDERFULPAST_LIST: {
        "code": 1,
        "data": [
            {
                "id": '-1',
                "activityId": "-1",
                "title": "见缝插针式组内密谋",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "coverPicture": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/jianfengchazhen1.jpg",
                "type": 1,
                "url": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/jianfengchazhen1.jpg,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/jianfengchazhen2.jpg,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/jianfengchazhen3.jpg,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/jianfengchazhen4.jpg",
                "introduction": "五天时间很短，除去体验的环节，留给营员们独立做任务的时间并不多。所以营员们抓紧一切时间进行组内讨论：餐桌上、旅馆内、大巴车上、小黑屋内……任何一个空闲的场所都成为他们的临时讨论地。披星戴月，每天回到驻地都星光满天，晚上还要继续忙碌到凌晨。负责拍摄任务同时是A组队员的罗宪茹说，从来没有连续无间断地做这多事，讨论的时候在剪片，皮影制作的时候在拍摄，睡觉做梦都梦见自己剪的片子。正是通过这些素材的搜集视频的连接，和小伙伴们熬夜熬出来的友谊，让我收获颇多～虽然或多或少都有些遗憾，但是从这些经历中得到很多宝贵的经验，继续帮助我成为更好的自己～(o^^o)",
                "tag": "随处可见的讨论",
                "tagList": ["随处可见的讨论"],
                "source": "全国"
            },
            {
                "id": '-2',
                "activityId": "-1",
                "title": "备受青睐的营品",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "coverPicture": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/beishouqinglai1.jpg",
                "type": 1,
                "url": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/beishouqinglai1.jpg,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/beishouqinglai2.jpg,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/beishouqinglai3.jpg",
                "introduction": "主办方为本次活动特意设计了一套主题营旗、营衫、营册、营牌，白底红字衬托出洋溢多彩的青春气息。不少参与了活动的人都希望能留一件营衫作纪念，以此致青春。",
                "tag": "营品",
                "tagList": ["营品"],
                "source": "全国"
            },
            {
                "id": '-3',
                "activityId": "-1",
                "title": "与蜜蜂的爱恨情仇",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "coverPicture": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/yumifeng.jpg",
                "type": 1,
                "url": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/yumifeng.jpg",
                "introduction": "营员在两个传统村落工作期间，得到当地乡民的亲切关照，不仅提供电风扇、西瓜等降暑单品，还牺牲午睡时间全程为营员进行讲解。就在活动结束后营员们返程之时，一位营员不小心被蜜蜂蛰到了手指，不一会儿整个指头都肿了起来，当地村民给予了土方治疗，不多久肿消疼退，也让营员以“痛”的代价领悟了农村生活的自然有序。",
                "tag": "痛的体验",
                "tagList": ["痛的体验"],
                "source": "全国"
            },
            {
                "id": '-4',
                "activityId": "-1",
                "title": "与“秋老虎”的抗争",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "coverPicture": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/yuqiulaohu2.png",
                "type": 1,
                "url": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/yuqiulaohu2.png,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/yuqiulaohu1.jpg,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/yuqiulaohu3.jpg",
                "introduction": "8月7日立秋，北京已有丝丝秋意，地处内陆腹地的红安却热得不像话。营员们除了要起早贪黑，还要和“秋老虎”作斗争。祝家楼调研的午后下了一场太阳雨，地面的热气蒸腾后焐得更加闷不透气，汗如雨下。想必这场历劫之后营员们的抗热指数又能增加几个点。来自福建的A组副队长蔡亦青感慨道，作为一个亚热带长大的娃最终也没能抵过红安的炎热，居然被热“感冒😷”了，此次红安之行的日均出汗量应该创下历史纪录，室外做日光浴，室内做桑拿。B队队长张冉说，营期虽已结束，感情却不会就此打住。圈内同志们都懂，但凡一起熬过夜画过图的，革命友谊来得更深刻，更何况是白天烈日暴晒，徒步村落，晚上挑灯夜读，头脑风暴。这个过程承载了我们年轻人为保护传统村落出谋划策的远大理想，也彰显了我们年少青春的肆意疯狂。",
                "tag": "热得不像话",
                "tagList": ["热得不像话"],
                "source": "全国"
            },
            {
                "id": '-5',
                "activityId": "-1",
                "title": "直播之“明日网红”",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "coverPicture": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/mingriwanghong1.jpg",
                "type": 1,
                "url": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/mingriwanghong1.jpg,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/mingriwanghong2.jpg",
                "introduction": "本次活动全程在目睹和QQNOW两个平台进行了重点环节直播尝试，竟也吸引了一票人围观，主播戏称自己为“明日网红”。从聊天记录来看，围观的学生居多，而在活动还是报名期间，就有不少家长打来电话，为子女探路并报名，让我们看到关注传统村落的群体范围其实很庞大，家长们在其中也扮演了重要角色，毕竟“下乡吃苦”这件事不是所有家长都能接受，但从这次活动情况来看，保护传统村落还需要更多发动家长们的力量。",
                "tag": "在现直播",
                "tagList": ["在现直播"],
                "source": "全国"
            },
            {
                "id": '-6',
                "activityId": "-1",
                "title": "特色农事体验“剥虾”",
                "activityName": "2018随行红安—中国传统村落大学生暑期工作营",
                "coverPicture": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/boxia1.jpg",
                "type": 1,
                "url": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/boxia1.jpg,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/boxia2.jpg,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/boxia3.jpg,https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/boxia4.jpg",
                "introduction": "红安地处山区，农业耕种受地形限制难大规模开展，村民选择承包农田搞养殖业，采用虾稻混养的生态方式养殖小龙虾。为了给紧张忙碌的工作营带去一丝休闲，主办方安排了一场特色农事体验，营员们在第三天任务结束后体验亲手抓小龙虾、去虾线、洗虾的全过程，完工后就地用压水泵抽水洗脸，体验了与城市灯红酒绿有别的农家田园生活，在情感上更贴近乡村。",
                "tag": "体验农家趣事",
                "tagList": ["体验农家趣事"],
                "source": "全国"
            },
            {
                "id": '-7',
                "activityId": "-2",
                "title": "制作成果展示",
                "activityName": "2019随行潜山—中国传统村落大学生暑期工作营",
                "coverPicture": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhubianzuopin.jpg",
                "type": 1,
                "url": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhubianzuopin.jpg",
                "introduction": "在杨家花屋前由清华大学的黄蔚欣老师和北京林业大学郑小东老师设计的两个竹构已见雏形。营员在老师团队的指导下学习了竹构搭建，与当地的工人师傅们一起完成了绑麻绳和空间定位等一系列工作，最终在结营前一天晚上见到了两个竹构作品的落成。在灯光点亮后，形成了动人的空间效果，吸引了不少当地村民前来观看。不管在白天还是夜晚，两个竹构形成的公共空间为旁边的杨家花屋甚至整个村落带来了活力。",
                "tag": "竹编作品",
                "tagList": ["竹编作品"],
                "source": "全国"
            },
            {
                "id": '-8',
                "activityId": "-2",
                "title": "竹构考察现场",
                "activityName": "2019随行潜山—中国传统村落大学生暑期工作营",
                "coverPicture": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhugoukaochaxianchang.jpg",
                "type": 1,
                "url": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/zhugoukaochaxianchang.jpg",
                "introduction": "万涧村有丰富的竹资源，当地人经常使用竹子进行各种器物的制作。在当地的竹编厂，笔者见识到了竹资源的多种营造方式。一器之微，穷工极巧，一根根竹子在师傅手中上下飞舞，转眼间变为精美的灯罩与竹席等，令人叹为观止。",
                "tag": "现场考察",
                "tagList": ["现场考察"],
                "source": "全国"
            },
            {
                "id": '-9',
                "activityId": "-2",
                "title": "手绘地图制作",
                "activityName": "2019随行潜山—中国传统村落大学生暑期工作营",
                "coverPicture": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/mapzhizuoxianchang.jpg",
                "type": 1,
                "url": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/mapzhizuoxianchang.jpg",
                "introduction": "在工作营老师的指导下，营员们为万涧村绘制了一幅手绘地图，以一年的十二时令为线，将万涧村的自然景观与人文景观串联起来，形成一幅空间位置相对准确，又富含万涧村故事的手绘地图。我们组的队员们走进当地居民的家中，倾听乡亲们讲述当地故事与习俗，并勾勒在了整个手绘地图上。让手绘地图讲故事，也让万涧村的记忆有所依存。",
                "tag": "手绘地图",
                "tagList": ["手绘地图"],
                "source": "全国"
            },
            {
                "id": '-10',
                "activityId": "-2",
                "title": "学习VR全景制作",
                "activityName": "2019随行潜山—中国传统村落大学生暑期工作营",
                "coverPicture": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/vrzhizuo.jpg",
                "type": 1,
                "url": "https://resource-1258796684.cos.ap-shanghai.myqcloud.com/wholesuixing/vrzhizuo.jpg",
                "introduction": "在中规院数博团队的老师指导下，VR组营员们用无人机对万涧全村进行数据采集，从而绘制出万涧村的VR全景地图，可以更好展现万涧的实景，并且能够更方便地传播推广",
                "tag": "学习VR制作",
                "tagList": ["学习VR制作"],
                "source": "全国"
            },
        ],
        "msg": null,
        "size": null,
        "totalCount": 6
    },
}